<ara-popover [content]="popoverContent()">
	<span class="ara-link__inner">
		@if (renderIcon()) {
			<mat-icon class="ara-link__icon" [svgIcon]="iconName()"></mat-icon>
		}
		<span class="ara-link__text"><ng-content></ng-content></span>
	</span>
</ara-popover>
